import { lazy } from "react";
import { Route } from "react-router-dom";
import Index from "@/pages/Index";

// Lazy load non-critical routes
const Pricing = lazy(() => import("@/pages/Pricing"));
const Customers = lazy(() => import("@/pages/Customers"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const Terms = lazy(() => import("@/pages/Terms"));
const Cookies = lazy(() => import("@/pages/Cookies"));
const Insights = lazy(() => import("@/pages/Insights"));
const InsightArticle = lazy(() => import("@/pages/InsightArticle"));
const SitemapGenerator = lazy(() => import("@/pages/dev/SitemapGenerator"));

const MarketingRoutes = () => {
  return (
    <>
      <Route path="/" element={<Index />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/customers/*" element={<Customers />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/cookies" element={<Cookies />} />
      <Route path="/insights" element={<Insights />} />
      <Route path="/insights/:slug" element={<InsightArticle />} />
      
      {/* Developer tools - only accessible in development */}
      <Route path="/dev/sitemap-generator" element={<SitemapGenerator />} />
    </>
  );
};

export default MarketingRoutes;